// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.offer-check-modal-btn{
    display: flex;
    justify-content: center;
    gap:2rem;
    margin-top: 4rem;
}

.offer-check-text{
    font-size: 1.3rem !important;
    text-align: center;
    margin-top: 4rem;
}

.offer-check-wrappper-inner-box{
   vertical-align: middle;
}

.offer-check-modal-btn-main{
    position: absolute;
    top: 82%;
    left: 0;
    display: flex;
    justify-content: center;
    padding: 2rem;
    width: 100%;
    z-index: 9999;
    gap: 10px;
}`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/all-products/components/twoWaykeyboardPaymentPage/components/offerCheckModal/index.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,4BAA4B;IAC5B,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;GACG,sBAAsB;AACzB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,aAAa;IACb,uBAAuB;IACvB,aAAa;IACb,WAAW;IACX,aAAa;IACb,SAAS;AACb","sourcesContent":[".offer-check-modal-btn{\n    display: flex;\n    justify-content: center;\n    gap:2rem;\n    margin-top: 4rem;\n}\n\n.offer-check-text{\n    font-size: 1.3rem !important;\n    text-align: center;\n    margin-top: 4rem;\n}\n\n.offer-check-wrappper-inner-box{\n   vertical-align: middle;\n}\n\n.offer-check-modal-btn-main{\n    position: absolute;\n    top: 82%;\n    left: 0;\n    display: flex;\n    justify-content: center;\n    padding: 2rem;\n    width: 100%;\n    z-index: 9999;\n    gap: 10px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
